import {Button} from '@wandb/weave/components';
import {Pill} from '@wandb/weave/components/Tag';
import {differenceInDays} from 'date-fns';
import * as React from 'react';
import {useContext} from 'react';

import {
  AccountSelectorContext,
  AccountType,
} from '../../../components/Search/SearchNav/AccountSelectorContextProvider';
import {useTrialCardAccountExpirationQuery} from '../../../generated/graphql';
import {PlanName} from '../../../pages/Billing/util';
import {Analytics} from '../../../services/analytics';
import {
  isTrialPlanPrimaryPlan,
  useGetSubscriptionPlanByName,
} from '../../../util/accounts/pricing';
import {navigateTo} from '../../../util/history';
import {useRampFlagAccountSelector} from '../../../util/rampFeatureFlags';
import {trialEndPage} from '../../../util/urls';

export const TrialCard = () => {
  const {selectedAccount} = useContext(AccountSelectorContext);
  const enableAccountSelector = useRampFlagAccountSelector();
  const {loading: loadingPlan, plans} = useGetSubscriptionPlanByName();
  const skip =
    selectedAccount == null ||
    selectedAccount.accountType === AccountType.Personal;
  const {loading: loadingExpiration, data} = useTrialCardAccountExpirationQuery(
    {
      variables: {organizationId: selectedAccount?.id ?? ''},
      skip,
    }
  );

  if (loadingPlan || loadingExpiration || !enableAccountSelector || skip) {
    return null;
  }

  // show for reverse trials only for now
  const reverseTrialPlan = data?.organization?.subscriptions?.find(
    subscription => isTrialPlanPrimaryPlan(subscription.plan)
  );

  if (reverseTrialPlan == null) {
    return null;
  }
  const accountExpiration = reverseTrialPlan.expiresAt;

  let daysUntilExpired: number | null = null;
  if (accountExpiration != null) {
    daysUntilExpired = differenceInDays(
      new Date(accountExpiration),
      new Date()
    );
  }

  const downgradePlanName = PlanName.CommunityEdition;

  const downgradePlan = plans[downgradePlanName];

  const freePlanText = downgradePlan
    ? `${downgradePlan.displayName} plan`
    : 'free plan';

  return (
    <div className="m-8 rounded-lg border border-moon-300 p-12">
      <div className="flex items-center justify-between ">
        <div className="text-base">Team's trial</div>
        {daysUntilExpired != null &&
          (daysUntilExpired > 0 ? (
            <Pill
              label={`${daysUntilExpired} days left`}
              className="p-12"
              color="teal"
            />
          ) : (
            <Pill label="Expired" className="p-12" color="red" />
          ))}
      </div>
      <div className="mb-8 mt-4 text-xs text-moon-600">
        At the end of the trial, purchase a plan or downgrade to the{' '}
        {freePlanText}.
      </div>
      <Button
        size="small"
        onClick={() => {
          Analytics.track(`Choose Plan Clicked`, {
            location: 'Sidebar Trial Card',
            daysUntilExpired,
          });
          navigateTo({pathname: trialEndPage()});
        }}>
        {daysUntilExpired == null || daysUntilExpired > 0
          ? 'Manage plan'
          : 'Choose plan'}
      </Button>
    </div>
  );
};
